import React from "react";
import Lottie from "react-lottie";
import * as DashboardTimer from "../Lottifiers/DashboardTimer.json";

export default function DashboardTimerr() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: DashboardTimer,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Lottie options={defaultOptions} height={"8.375em"} width={"8.375em"} />
  );
}
